import { useQuery } from "@apollo/client/react";
import { GuestCurrentDocument } from "@repo/graphql/documents/guest/query.generated";

/**
 * The campaign this browser started without an account, read from the backend: the
 * session cookie is the state, so a reload simply asks again. `current` is null when
 * there is none (never started, expired or already claimed); `loading` is true only
 * until the first answer, so a cached campaign shows at once while it is re-checked.
 *
 * `skip` leaves the question unasked (a signed-in visitor has no guest campaign).
 */
const useGuestCurrent = (skip = false) => {
  const { data, loading } = useQuery(GuestCurrentDocument, {
    skip,
    fetchPolicy: "cache-and-network",
  });
  return { current: data?.guest.current ?? null, loading: loading && !data };
};

export default useGuestCurrent;
